import { render, staticRenderFns } from "./CookiePreferences.vue?vue&type=template&id=23a8bfb8&scoped=true&"
import script from "./CookiePreferences.vue?vue&type=script&lang=ts&"
export * from "./CookiePreferences.vue?vue&type=script&lang=ts&"
import style0 from "./CookiePreferences.vue?vue&type=style&index=0&id=23a8bfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8bfb8",
  null
  
)

export default component.exports